// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"Default_testimonial__oCEAR","position":"Default_position__43pct"};